import React from 'react';

/**
 * 大屏专用装饰性 SVG 集，1:1 抠自产品原型（public/delivery-monitor/index.html）。
 * 三个组件都是纯静态 SVG，颜色/朝向/选中态通过 props 注入以支持 bucket 语义。
 */

interface CarIconProps {
    /** bucket 颜色（LEADING 绿 / NORMAL 青 / LAGGING 黄） */
    color: string;
    /** 选中时白色描边加粗，未选中半透明细描边 */
    selected?: boolean;
}

/** 小车 marker：34×46 汽车俯视图。旋转在外层容器控 transform，SVG 本身不转。 */
export const CarIcon: React.FC<CarIconProps> = ({ color, selected = false }) => (
    <svg width="34" height="46" viewBox="0 0 34 46">
        <ellipse cx="17" cy="23" rx="16" ry="22" fill="rgba(2,14,28,.42)" />
        <rect
            x="5"
            y="3"
            width="24"
            height="40"
            rx="9.5"
            fill={color}
            stroke={selected ? '#ffffff' : 'rgba(2,18,34,.55)'}
            strokeWidth={selected ? 2.4 : 1.2}
        />
        <rect x="1.6" y="16" width="3.4" height="6" rx="1.6" fill={color} />
        <rect x="29" y="16" width="3.4" height="6" rx="1.6" fill={color} />
        <path
            d="M9 14.5c1.4-3 3.6-4.6 8-4.6s6.6 1.6 8 4.6c-5.2-1.5-10.8-1.5-16 0z"
            fill="rgba(2,18,34,.72)"
        />
        <path
            d="M9 31.5c1.4 3 3.6 4.6 8 4.6s6.6-1.6 8-4.6c-5.2 1.5-10.8 1.5-16 0z"
            fill="rgba(2,18,34,.72)"
        />
        <rect x="10" y="16.5" width="14" height="13" rx="3.4" fill="rgba(255,255,255,.22)" />
        <rect x="8.4" y="4.4" width="4" height="2.6" rx="1.3" fill="rgba(255,255,255,.75)" />
        <rect x="21.6" y="4.4" width="4" height="2.6" rx="1.3" fill="rgba(255,255,255,.75)" />
    </svg>
);

/** 皇冠：LEADING 桶妥投率 top1 的司机头顶挂一顶。26×20，金色 `#ffd54a`。 */
export const CrownIcon: React.FC = () => (
    <svg width="26" height="20" viewBox="0 0 26 20">
        <path
            d="M2.5 15.5 1 4.6l6.2 4.1L13 1.6l5.8 7.1L25 4.6l-1.5 10.9z"
            fill="#ffd54a"
            stroke="#5c3c00"
            strokeWidth="1.1"
            strokeLinejoin="round"
        />
        <rect
            x="2.4"
            y="16.4"
            width="21.2"
            height="2.6"
            rx="1.3"
            fill="#ffd54a"
            stroke="#5c3c00"
            strokeWidth="1"
        />
    </svg>
);

/** 仓库 marker：56×66 紫色房子。用于地图上标记当前选中的 WHS，纯展示不带交互。 */
export const WhsMarkerIcon: React.FC = () => (
    <svg
        width="56"
        height="66"
        viewBox="0 0 56 66"
        style={{ filter: 'drop-shadow(0 4px 10px rgba(0,0,0,.65))' }}
    >
        <path
            d="M28 64C28 64 51 37 51 24.5A23 23 0 1 0 5 24.5C5 37 28 64 28 64Z"
            fill="#a78bfa"
            stroke="#f1ecff"
            strokeWidth="2.6"
        />
        <g fill="none" stroke="#241269" strokeWidth="2.6" strokeLinejoin="round" strokeLinecap="round">
            <path d="M16 25.5L28 15l12 10.5" />
            <path d="M19 25v11h18V25" />
            <path d="M25 36v-6.5h6V36" />
        </g>
    </svg>
);
